<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <div style="float: left">
        <span class="title" >余额：{{amountPlus}}港元</span>
        </div>
        <div style="float: right">
          <div >
            <router-link style="background-color: red;color: white;padding: 5px 20px 5px 20px; border-radius: 25px" :to="{name:'Protocol',params:{type:21}}">使用须知</router-link>
          </div>
        </div>
      </div>
          <el-table
            :data="all_coupon"
            stripe
            size="mini"
            style="width: 100%; font-size: 16px">
            <el-table-column
              prop="name"
              align="center"
              label="赠送日期">
              <template slot-scope="scope">
                <p style="font-size: 15px">{{ scope.row.time }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="short"
              align="center"
              label="到期日期">
              <template slot-scope="scope">
                <p style="font-size: 15px">{{ scope.row.effect_date }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              label="金额">
              <template slot-scope="scope">
                <p style="font-size: 15px">{{ scope.row.amount }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="surplus"
              align="center"
              label="状态">
              <template slot-scope="scope">
                <p style="font-size: 15px">{{ scope.row.statustext }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="frozen"
              align="center"
              label="推广二维码/链接">
              <template slot-scope="scope">
                <p v-if="scope.row.status === 1" @click="agencyQr(scope.row.coupon,scope.row.amount)"><span style="font-size: 15px;color: #606266;font-weight: 600;cursor: pointer">详情></span></p>
              </template>
            </el-table-column>
          </el-table>
    </el-card>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "friendcoupon",
  data(){
    return{
      all_coupon:[],
      amountPlus : 0
    }
  },
  created() {
    this.$store.state.accountType = 7;
  },
  mounted(){
    this.getAllDepot();
  },
  methods:{
    getAllDepot() {
      let that = this;
      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: 'friend_coupon',
          token: window.sessionStorage.getItem('token'),
        }
      })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.all_coupon = resData.data;

            for (let i = 0; i < that.all_coupon.length; i++) {
             if(that.all_coupon[i].status === 1){
               that.amountPlus = that.amountPlus + that.all_coupon[i].amount;
             }
            }
          } else if (resData.code == 0 || resData.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },

    agencyQr(id,no){
      this.$store.commit("couponAmountCheck", no);
      this.$store.commit("couponNoCheck", id);

      this.$router.push({
        path: "/myaccount/agency"
      });
      // this.$store.state.couponNo = id;
      // this.$store.state.couponAmount = no;
    }
  },
}
</script>

<style scoped>
.changePage{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/friendcoupon.vue